import React from 'react';
import { X, Plus, Minus, ShoppingBag, ArrowRight } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { useNavigate } from 'react-router-dom';

const CartDrawer = () => {
  const { cartItems, isCartOpen, setIsCartOpen, updateQuantity, removeFromCart, subtotal } = useCart();
  const navigate = useNavigate();
  
  const freeShippingLimit = 2000;
  const progress = Math.min((subtotal / freeShippingLimit) * 100, 100);

  if (!isCartOpen) return null;

  return (
    <div className="fixed inset-0 z-[1000] overflow-hidden">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm transition-opacity" onClick={() => setIsCartOpen(false)} />
      <div className="absolute inset-y-0 right-0 max-w-full flex">
        <div className="w-screen max-w-md bg-white shadow-2xl flex flex-col animate-in slide-in-from-right duration-300">
          
          <div className="px-6 py-6 border-b flex items-center justify-between">
            <div className="flex items-center gap-3">
              <ShoppingBag size={20} className="text-black" />
              <h2 className="text-xl font-black uppercase italic tracking-tighter">Your Bag</h2>
              <span className="bg-black text-white text-[10px] px-2 py-0.5 rounded-full font-bold">{cartItems.length}</span>
            </div>
            <button onClick={() => setIsCartOpen(false)} className="p-2 hover:bg-gray-100 rounded-full transition-colors">
              <X size={24} />
            </button>
          </div>

          <div className="px-6 py-4 bg-gray-50">
            <p className="text-[10px] font-black uppercase tracking-widest mb-2 italic">
              {subtotal >= freeShippingLimit ? "✨ FREE SHIPPING UNLOCKED" : `Add ₹${freeShippingLimit - subtotal} more for FREE SHIPPING`}
            </p>
            <div className="w-full h-1.5 bg-gray-200 rounded-full overflow-hidden">
              <div className="h-full bg-black transition-all duration-500" style={{ width: `${progress}%` }} />
            </div>
          </div>

          <div className="flex-1 overflow-y-auto px-6 py-4 space-y-6">
            {cartItems.length === 0 ? (
              <div className="h-full flex flex-col items-center justify-center text-center space-y-4 text-gray-400">
                <ShoppingBag size={40} />
                <p className="font-black uppercase italic">Bag is empty</p>
              </div>
            ) : (
              cartItems.map((item) => (
                <div key={`${item.id}-${item.selectedSize}`} className="flex gap-4">
                  <div className="w-20 aspect-[3/4] rounded-xl overflow-hidden bg-gray-100">
                    <img src={item.img} alt={item.name} className="w-full h-full object-cover" crossOrigin="anonymous" />
                  </div>
                  <div className="flex-1 flex flex-col justify-between">
                    <div>
                      <h3 className="text-xs font-black uppercase">{item.name}</h3>
                      <p className="text-[10px] font-bold text-gray-400">Size: {item.selectedSize}</p>
                    </div>
                    <div className="flex justify-between items-center">
                      <div className="flex items-center gap-2 bg-gray-50 rounded px-2 py-1">
                        <button onClick={() => updateQuantity(item.id, item.selectedSize, -1)}><Minus size={10} /></button>
                        <span className="text-xs font-black">{item.quantity}</span>
                        <button onClick={() => updateQuantity(item.id, item.selectedSize, 1)}><Plus size={10} /></button>
                      </div>
                      <p className="font-black">₹{item.price * item.quantity}</p>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>

          {cartItems.length > 0 && (
            <div className="border-t p-6 space-y-4">
              <div className="flex justify-between text-xl font-black italic">
                <span>Total</span>
                <span>₹{subtotal}</span>
              </div>
              <button 
                onClick={() => {setIsCartOpen(false); navigate('/checkout');}}
                className="w-full bg-black text-white py-4 rounded-xl font-black uppercase italic tracking-widest flex items-center justify-center gap-2"
              >
                Checkout <ArrowRight size={18} />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CartDrawer;